/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-custom-scrollbars/lib/utils/returnFalse.js
 ** module id = 1607
 ** module chunks = 0
 **/